var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1442_729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.0001 33.2837V12.2508C42.0001 12.2175 41.9984 12.1843 41.9949 12.1519C41.9791 12.0198 41.8243 10.8368 41.0193 10.0327L31.9684 0.982691C31.1634 0.177703 29.9813 0.0219557 29.8501 0.00708097C29.8169 0.00358666 29.7836 0.00183428 29.7503 0.00183105H7.87566C5.46333 0.00183105 3.50073 1.96443 3.50073 4.37676V44.6261C3.50073 47.0385 5.46333 49.0011 7.87566 49.0011H30.6349C32.3919 53.2124 36.5315 56.001 41.1251 56.001C47.397 56.001 52.5 50.898 52.5 44.6261C52.5 38.6474 47.8643 33.7326 42.0001 33.2837Z",
    fill: "url(#paint0_linear_1442_729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0184 10.0318L31.9684 0.982663C31.1634 0.177675 29.9813 0.0219277 29.8501 0.00705297C29.7276 -0.00701972 29.6035 0.00499023 29.4859 0.0422937C29.3684 0.0795972 29.2601 0.14135 29.1681 0.223494C29.0761 0.305639 29.0025 0.406316 28.9522 0.518911C28.9019 0.631506 28.876 0.75347 28.8762 0.876789V8.75167C28.8762 11.164 30.8388 13.1266 33.2512 13.1266H41.126C41.2492 13.1264 41.371 13.1002 41.4834 13.0497C41.5958 12.9993 41.6963 12.9258 41.7783 12.8339C41.8604 12.742 41.9222 12.6338 41.9596 12.5165C41.9971 12.3991 42.0094 12.2752 41.9958 12.1527C41.9791 12.0189 41.8234 10.8368 41.0184 10.0318Z",
    fill: "url(#paint1_linear_1442_729)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1252 56C47.4073 56 52.5 50.9073 52.5 44.6251C52.5 38.343 47.4073 33.2503 41.1252 33.2503C34.843 33.2503 29.7504 38.343 29.7504 44.6251C29.7504 50.9073 34.843 56 41.1252 56Z",
    fill: "#1062D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4583 44.627H45.7944",
    stroke: "#F7F8FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1259 39.9585V49.2946",
    stroke: "#F7F8FA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1442_729",
    x1: 5.50708,
    y1: 48.4411,
    x2: 42.4674,
    y2: 11.4808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3D8F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E7F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1442_729",
    x1: 30.1581,
    y1: 11.843,
    x2: 36.4939,
    y2: 5.50722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98B9D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEEAFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1442_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/addFile.3a9366cebfeb0005223399a55765b973.svg";
export { ForwardRef as ReactComponent };